export const KEYWORDS = {
    DEF_MANDATAIRE: "DefMandataire",
    DEF_PRESTATAIRE: "DefPrestataire",
    DEF_POINTAGE: "DefPointage",
    DEF_CONGES: "DefConges",
    PSYCHOLOGIC: "SoutienPsy",
    SOCIAL: "SoutienSocial",
    DEV_CHARTE: "DefCharte"
}